import { SortingFn } from '@tanstack/react-table';

const compareVersionStrings = (a: string, b: string): number => {
  if (a === b) return 0;
  if (!a) return -1;
  if (!b) return 1;

  const partsA = a.split('.');
  const partsB = b.split('.');
  const maxLength = Math.max(partsA.length, partsB.length);

  for (let i = 0; i < maxLength; i++) {
    const partA = partsA[i] || '';
    const partB = partsB[i] || '';

    if (partA === '' && partB !== '') return -1;
    if (partA !== '' && partB === '') return 1;

    const isNumA = /^\d+$/.test(partA);
    const isNumB = /^\d+$/.test(partB);

    if (isNumA && isNumB) {
      const numA = parseInt(partA, 10);
      const numB = parseInt(partB, 10);
      if (numA !== numB) return numA - numB;
    } else if (isNumA) {
      return -1;
    } else if (isNumB) {
      return 1;
    } else {
      const cmp = partA.localeCompare(partB);
      if (cmp !== 0) return cmp;
    }
  }

  return 0;
};

export const versionSortingFn: SortingFn<any> = (rowA, rowB, columnId) => {
  const a = String(rowA.getValue(columnId) ?? '');
  const b = String(rowB.getValue(columnId) ?? '');
  const result = compareVersionStrings(a, b);
  return result;
};
